import React from 'react'

//assets
import { HiChevronDown } from "react-icons/hi";

function Accordion({ title, description }) {
    return (
        <div>
            <div className='flex flex-row py-24 px-28 bg-white rounded-4 border-1 justify-center items-center space-x-48'>
                <div className='flex flex-col w-full space-y-16'>
                    <div className='text-14 font-semibold text-gray-600'>
                        {title}
                    </div>
                    {description && (
                        <div className='text-14 font-regular text-gray-400'>
                            {description}
                        </div>
                    )}
                </div>
                <div>
                    <HiChevronDown />
                </div>
            </div>
        </div>
    )
}

export default Accordion